import { __exports as intlDurationformat } from "../../../_virtual/index.mjs";
import require$$0 from "../../../_virtual/tslib.es6.mjs";
import { __require as requireCore } from "./src/core.mjs";
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var tslib_1 = require$$0;
  tslib_1.__exportStar(requireCore(), exports);
})(intlDurationformat);
